<template>
	<JBox>
		<JBox class="s-p-8">
			<JBox class="s-mb-6">
				<JLabel class="s-w-full">{{ $t("products.benefitTypeId") }}</JLabel>
				<JBox class="s-text-gray-600">{{ form.typeId }}</JBox>
			</JBox>

			<JBox class="s-mb-6" v-if="form.optionKey">
				<JLabel class="s-w-full">Option Key</JLabel>
				<JBox class="s-text-gray-600">{{ form.optionKey }}</JBox>
			</JBox>

			<CFormInput
				:label="`Name ${localeName}`"
				description="Localized name of the benefit"
				componentName="JInputText"
				name="name"
				class="s-mb-6"
				v-model="form.name"
				@input="handleInput"
			/>

			<CFormInput
				:label="`Description ${localeName}`"
				description="Localized description of the benefit"
				componentName="JInputText"
				name="description"
				class="s-mb-6"
				v-model="form.description"
				@input="handleInput"
			/>

			<CFormInput
				label="Currency Code"
				componentName="JSelect"
				name="currencyCode"
				class="s-mb-6"
				:options="currencyCodes"
				v-model="form.currencyCode"
				@input="handleInput"
			/>

			<CFormInput
				label="Parent Option Keys"
				description="List all the parent option keys you need and separate them by a comma"
				componentName="JInputText"
				name="parentOptionKeys"
				class="s-mb-6"
				v-model="form.parentOptionKeys"
				@input="handleInput"
			/>

			<!-- If isValueInput, user will input value manually and values is not displayed -->
			<JBox class="s-mb-6" v-if="form.isValueInput">
				<JLabel class="s-w-full">Benefit Value</JLabel>
				<JBox class="s-text-gray-600">Manual Input - value is added by user manually</JBox>
			</JBox>

			<template v-if="!form.isValueInput">
				<CFormInput
					label="Value"
					subheadline="Raw benefit value, it is not localized thus is the same across all locales"
					:componentName="CTypedValueInput"
					name="value"
					class="s-mb-6"
					v-model="form.rawData"
					@input="handleInput"
					@dataType="handleType"
				/>

				<JBox class="s-mb-6">
					<CFormInput
						:label="$t('products.shortValue') + ' ' + localeName"
						:description="$t('products.localizedShortValue')"
						componentName="JInputText"
						name="shortValue"
						class="s-mb-6"
						v-model="form.value"
						@input="handleInput"
					/>
				</JBox>

				<JBox class="s-mb-6">
					<CFormInput
						:label="$t('products.detailedValue') + ' ' + localeName"
						:description="$t('products.localizedDetailedValue')"
						componentName="JInputLongText"
						name="detailedValue"
						v-model="form.detailedValue"
						@input="handleInput"
					/>
					<JText class="s-text-sm s-text-indigo-600 s-cursor-pointer" @click="isHelpVisible = !isHelpVisible"
						>{{ $t("products.seeLocalizationInstructions") }}
					</JText>
					<JBox v-if="isHelpVisible" class="s-text-sm s-bg-blue-50 s-border s-border-blue-100 s-p-4 s-rounded s-mb-1">
						<ul>
							<li>{{ $t("products.toReferenceCurrencyCode") }}</li>
							<li>{{ $t("products.toReferenceValue") }}</li>
						</ul>
						<br />
						{{ $t("products.forExample") }}<br />
						{{ $t("products.whenValueIs12AndCurrencyCodeIsHKD") }}
					</JBox>
				</JBox>
			</template>
		</JBox>
	</JBox>
</template>

<script>
import CTypedValueInput from "@/modules/core/components/CTypedValueInput"

export default {
	props: {
		value: {
			type: Object,
			default: () => ({})
		},
		locale: {
			type: String,
			default: () => ""
		}
	},

	data() {
		return {
			form: {},

			isHelpVisible: false,

			// Component injection for form
			CTypedValueInput: CTypedValueInput
		}
	},

	computed: {
		localeName() {
			const name = this.$store.getters.localeName(this.locale)
			return name ? `(${name})` : ""
		},

		currencyCodes() {
			return this.$store.getters.currencyCodes
		}
	},

	methods: {
		handleInput() {
			this.$emit("input", {
				...this.form,
				parentOptionKeys: this.form.parentOptionKeys ? this.form.parentOptionKeys.trim().split(",") : null
			}) // looks like "optino_0, option_1, option_2" --> ["option_1","option_2"]  })
		},
		handleType(type) {
			this.$emit("dataType", type)
		}
	},

	watch: {
		value: {
			handler(newVal) {
				this.form = {
					...newVal,
					parentOptionKeys: newVal?.parentOptionKeys?.join(",") ?? null // convert from array of strings to string
				}
			},
			immediate: true,
			deep: true
		}
	}
}
</script>
